




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { IUserProfile } from '@/shared/models';

export interface IMenuItem {
  to: string;
  icon: string;
  text: string;
}

@Component({
  name: 'Sidebar',
  components: {},
})
export default class Sidebar extends Vue {
  @Getter('userProfile') private profile!: IUserProfile;

  protected async logout() {
    const logoutSuccess = this.$store.dispatch('logout');
    if (logoutSuccess) {
      this.$router.push('/auth');
    }
  }

  protected listMenu: IMenuItem[] = [
    {
      to: '/',
      icon: 's-data',
      text: 'Tổng quan',
    },
    {
      to: '/users',
      icon: 's-custom',
      text: 'Quản lý người dùng',
    },
    {
      to: '/products',
      icon: 's-goods',
      text: 'Sản phẩm',
    },
    {
      to: '/services',
      icon: 'menu',
      text: 'Danh sách dịch vụ',
    },
    {
      to: '/history-transaction',
      icon: 's-data',
      text: 'Lịch sử giao dịch',
    },
    {
      to: '/support-center',
      icon: 's-help',
      text: 'Trung tâm trợ giúp',
    },
  ];
}
